import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';

const chartOptions = (categories, isDark, isRtl, xTitle = '', yTitle = '') => ({
  chart: {
    height: 360,
    type: 'bar',
    toolbar: { show: false },
  },
  dataLabels: { enabled: false },
  stroke: { width: 2, colors: ['transparent'] },
  colors: ['#EE1D23', '#1A2B5C'], // Red for Target, Blue for Achieved
  dropShadow: {
    enabled: true,
    blur: 3,
    color: '#808080', // Brand Gray
    opacity: 0.4,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      borderRadius: 8,
      borderRadiusApplication: 'end',
    },
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'center',
    fontSize: '14px',
    labels: {
      colors: isDark ? '#e0e6ed' : '#1A2B5C', // Blue for light, whiteish for dark
    },
    itemMargin: {
      horizontal: 8,
      vertical: 8,
    },
  },
  grid: {
    borderColor: isDark ? '#191e3a' : '#808080', // Gray
    padding: {
      left: 20,
      right: 20,
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  xaxis: {
    categories: categories,
    axisBorder: {
      show: true,
      color: isDark ? '#3b3f5c' : '#808080', // Gray
    },
    title: {
      text: xTitle,
      style: {
        color: isDark ? '#e0e6ed' : '#1A2B5C',
        fontSize: '14px',
        fontWeight: 600,
      },
    },
    labels: {
      style: {
        colors: isDark ? '#e0e6ed' : '#1A2B5C',
      },
    },
  },
  yaxis: {
    tickAmount: 6,
    opposite: isRtl,
    labels: {
      offsetX: isRtl ? -10 : 0,
      style: {
        colors: isDark ? '#e0e6ed' : '#1A2B5C',
      },
    },
    title: {
      text: yTitle,
      style: {
        color: isDark ? '#e0e6ed' : '#1A2B5C',
        fontSize: '14px',
        fontWeight: 600,
      },
    },
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: isDark ? 'dark' : 'light',
      type: 'vertical',
      shadeIntensity: 0.3,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.8,
      stops: [0, 100],
    },
  },
  tooltip: {
    marker: {
      show: true,
    },
  },
});

const BarChart = ({ data, xTitle = '', yTitle = '' }) => {
  // Ensure data is valid

  const isDark = useSelector((state) => state.themeConfig.theme === 'dark' || state.themeConfig.isDarkMode);
  const isRtl = useSelector((state) => state.themeConfig.rtlClass) === 'rtl' ? true : false;
  if (!data || !data.series || !data.categories) {
    return <div>Invalid data</div>;
  }

  const { series, categories } = data;
  const options = chartOptions(categories, isDark, isRtl, xTitle, yTitle);

  return (
    <div>
      <ReactApexChart options={options} series={series} type="bar" height={360} className="overflow-hidden" />
    </div>
  );
};

export default BarChart;
